var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.345 9.25H6.759C6.62607 9.24891 6.49905 9.19494 6.406 9.1L4.845 7.543C4.65751 7.35545 4.40319 7.25006 4.138 7.25H1.154C0.806695 7.24966 0.484086 7.42955 0.301814 7.72518C0.119542 8.02081 0.103712 8.38985 0.26 8.7L2.76 13.7C2.92818 14.0397 3.27493 14.2542 3.654 14.253H9.534C9.63525 14.2528 9.72662 14.3137 9.76539 14.4073C9.80416 14.5008 9.78269 14.6085 9.711 14.68L5.846 18.542C5.55951 18.8278 5.47347 19.258 5.62805 19.632C5.78263 20.006 6.14735 20.2499 6.552 20.25H10.138C10.4032 20.2499 10.6575 20.1446 10.845 19.957L16.406 14.4C16.4997 14.3065 16.6266 14.254 16.759 14.254H21.345C22.7257 14.254 23.845 13.1347 23.845 11.754C23.845 10.3733 22.7257 9.254 21.345 9.254V9.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.492 8.1C10.5857 8.19347 10.7126 8.24597 10.845 8.246H15.445C15.5461 8.24578 15.6371 8.18472 15.6756 8.09127C15.7141 7.99783 15.6926 7.89038 15.621 7.819L11.841 4.039C11.6535 3.85145 11.3992 3.74606 11.134 3.746H8.552C8.1476 3.74609 7.78307 3.98973 7.62832 4.36335C7.47358 4.73697 7.55909 5.16701 7.845 5.453L10.492 8.1Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlight);
export default __webpack_public_path__ + "static/media/flight.0731d5f4.svg";
export { ForwardRef as ReactComponent };